import { LabelCategory } from "@/api";

export const getLabelColor = (
  labelCategories: LabelCategory[] | undefined,
  labelPrimair: string
): string | undefined => {
  return (labelCategories ?? []).find(({ label }) => label === labelPrimair)?.color ?? undefined;
};

export const isOptimalisationLabel = (label: string | undefined) => label === "optimizable";
export const isBasisLabel = (label: string | undefined) => label === "basic";

export const getLabelLabel = (label: string | undefined) => {
  if (isBasisLabel(label)) return "Basis label";
  if (isOptimalisationLabel(label)) return "Optimalisatie label";
  return undefined;
};
